import { Star, Loader2 } from "lucide-react";

export const fmtCount = (n) => (n == null ? "?" : n >= 1000 ? `${(n / 1000).toFixed(1).replace(/\.0$/, "")}K` : String(n));

// "4.8 ★ (1.2K)" for one store; grey "?" when we couldn't read it
const Store = ({ label, avg, count, href, tone, testId }) => {
  const body = (
    <>
      <span className="font-bold text-slate-500">{label}</span>
      {avg != null && count ? <span className="inline-flex items-center gap-0.5"><b>{avg.toFixed(1)}</b><Star size={9} className="fill-current" /></span> : null}
      <span className={count == null ? "text-slate-600" : ""}>({fmtCount(count)})</span>
    </>
  );
  const cls = `inline-flex items-center gap-1 text-xs tabular-nums whitespace-nowrap ${tone}`;
  return href ? <a href={href} target="_blank" rel="noreferrer" title={`Open on ${label === "A" ? "Apple Podcasts" : "Spotify"}`} className={`${cls} hover:underline`} data-testid={testId}>{body}</a> : <span className={cls} data-testid={testId}>{body}</span>;
};

export const StoreRatings = ({ p, stacked = false }) => {
  if (p.screening) return <span className="inline-flex items-center gap-1 text-[10px] text-sky-300" data-testid="finder-prospect-screening"><Loader2 size={10} className="animate-spin" /> checking</span>;
  return (
    <span className={`flex ${stacked ? "flex-col gap-0.5" : "items-center gap-3"}`} data-testid="finder-prospect-ratings">
      <Store label="A" avg={p.apple_rating_avg} count={p.apple_ratings} href={p.apple_url} tone="text-slate-200" testId="finder-prospect-apple-rating" />
      <Store label="S" avg={p.spotify_rating_avg} count={p.spotify_ratings} href={p.spotify_url} tone="text-emerald-200" testId="finder-prospect-spotify-rating" />
    </span>
  );
};
